// extracted by mini-css-extract-plugin
export default {"wrapper":"imagePopUp_wrapper__IdOR+","overlay":"imagePopUp_overlay__vFGkB"};